import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import ItemListEditor from 'components/desktop/_general/ItemListEditor/ItemListEditor';
import * as AllergenList from 'types/_general/Store/AllergenList';

export const BaseIngredientAllergenCard = ({
	state,
	handlers,
	data,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-allergens-card"
			title={t('_general:ALLERGENS')}
			info={'_general:ALLERGEN_INFO_TOOLTIP'}
			content={
				<div className="card-body">
					<ItemListEditor
						allItems={AllergenList.mapToUniqIdList(data.allergens)}
						itemIds={state.allergenIds}
						setItemIds={handlers.setAllergenIds}
						noItemsMessage={t('_general:NO_ALLERGENS')}
					/>
				</div>
			}
		/>
	);
};
